import React from 'react';

const Button = ({ label, href, className, children }) => {
    return <a
        href={href}
        className={"inline-flex text-black bg-yellow-200 border-0 py-2 px-6 focus:outline-none hover:bg-yellow-600 rounded text-lg " + className}>{label || children}</a>
}

export default Button;